<template>
  <div ref="topbarheight" id="jo-topbar" class="jo-topbar">
    <div class="jo-banner" v-if="banner && showLink" id="jo-banner">
      <img id="topbarBanner" :src="banner" onerror="javascript:this.style='display:none';this.onerror=null">
    </div>
    <el-container>
      <el-container class="jocontainer">
        <el-main>
          <div>
            <h1 v-for="item in titlegroup.articletitle" v-if="item.lang == lang" class="topbar_title">
              <component :is="'jo' + item2.name" v-for="item2 in item.data" v-bind:key="item2.index" v-bind:data="item2.data"></component>
            </h1>
            <h1 v-if="titlegroup.articletitle.length==0 && ARTICLE.type != 'focus'">{{lang=='en'? 'None' : '无'}}</h1>
            <h1 v-else-if="titlegroup.articletitle.length==1 && (titlegroup.articletitle[0].lang !== lang || titlegroup.articletitle[0].data.length < 1)">
              {{lang=='en'? 'None' : '无'}}</h1>
            <h1 v-else-if="titlegroup.articletitle.length==1 && (titlegroup.articletitle[0].lang !== lang || titlegroup.articletitle[0].data.length < 1)">
              </h1>
            <h2 v-for="item in titlegroup.subtitle" v-if="item.lang == lang && titlegroup.hasOwnProperty('subtitle')" class="topbar_subtitle">
              <component :is="'jo' + item2.name" v-for="item2 in item.data" v-bind:key="item2.index" v-bind:data="item2.data"></component>
            </h2>
            <div>
              <ul class="jo-author-items">
                <li class="jo-author-item theme-font" v-for="(item, index) in contributes" :key="index">
                  <el-popover
                    placement="bottom"
                    width="400"
                    popper-class="popover theme-border"
                    v-model="showPopArray[index]"
                    transition="none"
                    trigger="click">
                    <ul class="popoverUl" :data="authorDetail">
                      <li v-if="authorDetail.orcid != ''">
                        <label>ORCID：</label><a :href="authorDetail.orcid" target="_blank">{{authorDetail.orcid}}</a>
                      </li>
                      <li v-if="authorDetail.mechanism&&authorDetail.mechanism.length!=0">
                        <label>{{lang == 'zh' ? '机 构：' : 'Affiliation：'}}</label><span
                        v-if="authorDetail.mechanism.length - 1 === 0">{{authorDetail.mechanism[0].text}}</span><span
                        v-else v-for="(item,index) in authorDetail.mechanism" :key="index" style="display:block;">
                                                    {{item.label ? `${item.label}. ${item.text}` : item.text}}
                                                </span>
                      </li>
                      <li v-if="authorDetail.role" v-for="role in authorDetail.role">
                        <label>{{lang == 'zh' ? '角 色：' : 'Role：'}}</label><span>{{role}}</span>
                      </li>
                      <li v-if="authorDetail.phone">
                        <label>{{lang == 'zh' ? '电 话：' : 'Telephone：'}}</label><span>{{ authorDetail.phone }}</span>
                      </li>
                      <li v-if="authorDetail.email">
                        <label>{{lang == 'zh' ? '邮 箱：' : 'Email：'}}</label><a :style="{'color':ARTICLE.theme}"
                        :href="'mailto:'+authorDetail.email">{{ authorDetail.email }}</a>
                      </li>
                      <li v-if="authorDetail.bioIntro && authorDetail.bioIntro.data.length>0">
                        <div><label>{{lang == 'zh' ? '作者简介：' : 'Profile：'}}</label>
                          <p><img v-for="item in authorDetail.bioIntro.graphic" :src="item.big"
                                  v-if="item.big && item.big != ''"
                                  v-bind:style="{ 'width': '100px','height':'auto'}"/></p>
                          <p><span v-for="(item,index1) in authorDetail.bioIntro.data" :key="'bio'+index + index1">
                        <component :is="'jo' + item2.name" v-for="item2 in item" v-bind:key="item2.index"
                                   v-bind:data="item2.data"></component>&nbsp;</span></p>
                        </div>
                      </li>
                      <li v-else-if="authorDetail.firstIntro">
                        <label>{{lang == 'zh' ? '作者简介：' : 'Profile：'}}</label><span
                        v-text="authorDetail.firstIntro"></span>
                      </li>
                      <li v-else-if="authorDetail.briefIntro">
                        <label>{{lang == 'zh' ? '作者简介：' : 'Profile：'}}</label><span
                        v-text="authorDetail.briefIntro"></span>
                      </li>
                      <li v-else-if="authorDetail.supervisorIntro">
                        <label>{{lang == 'zh' ? '导师简介：' : 'Tutor：'}}</label><span
                        v-text="authorDetail.supervisorIntro"></span>
                      </li>
                      <li v-if="authorDetail.noCnInfo&&lang == 'zh'">
                        <span>暂无本作者相关信息</span>
                      </li>
                      <li v-if="authorDetail.noEnInfo&&lang == 'en'">
                        <span>No detail information about the author</span>
                      </li>
                      <i class="el-icon-close" @click="closePopover(index)"></i>
                    </ul>
                    <span class="author" slot="reference" @click="showAuthorDetail(index)" @blur="currentPopover = -1">
                    <span v-if="item2.lang == lang" v-for="item2 in item.name">
                      <span :class="{'deceased' : item.deceased}">{{item2.prefix}} {{item2.namestyle == 'western' ?
                      (item2.givenname ? item2.givenname : '') + ' ' + item2.surname : item2.surname + (item2.lang == 'en' ||
                        /^[a-zA-Z. ]+$/.test(item2.surname) && /^[a-zA-Z. ]+$/.test(item2.givenname) ? ' ' : '') + (item2.givenname ? item2.givenname : '')}}</span>
                    <sup v-if="contribgroup.aff.length>1">{{authorAff[index]}}</sup>
                    <span v-if="item.supRole && item.supRole != ''" style="font-style: italic">({{item.supRole}})</span></span>
                    <span
                      v-if="(item.name.length < 1 || item.name.length == 1 && item.name[0].lang != lang)&& item2.lang == lang"
                      v-for="item2 in item.stringName">{{item2.prefix}} {{item2.surname}}
                    <sup v-if="contribgroup.aff.length>1">{{authorAff[index]}}</sup>
                    <span v-if="item.supRole && item.supRole != ''" style="font-style: italic">({{item.supRole}})</span>
                    <a v-if="item.name.length == 0" href="javascript:void(0);" v-on:click="sendEmail(item.email)" class="jo-email theme-color"><span
                      class="emailImg"
                      v-if="item.corresp && item.corresp.length>0 || item.role.indexOf('corresp')> -1 || item.email">✉</span></a>
                    </span>
                      <!--<sup v-for="aff in item.aff" :key="aff.text">{{ aff.text }}</sup>-->
                  </span>
                  </el-popover>
                  <a v-for="item2 in item.name"  v-if="item2.lang == lang && item.orcid && item.orcid != ''" class="jo-orcid" :href="item.orcid" target="_blank"><img
                    class="orcidImg" :src="orcidImgUrl"/></a>
                  <a v-for="item2 in item.name" v-if="item2.lang == lang" href="javascript:void(0);" v-on:click="sendEmail(item.email)" class="jo-email theme-color"><span
                    class="emailImg"
                    v-if="item.corresp && item.corresp.length>0 || item.role.indexOf('corresp')> -1 || item.email">✉</span></a>
                  <span v-for="item1 in item.collab" v-if="item1.lang == lang">{{item1.name}}</span>
                </li>
              </ul>
            </div>
            <div class="affs" v-if="contribgroup.aff.length > 0">

              <span class="mechanism" v-for="(item,index) in contribgroup.aff" :key="index"
                    v-if="contribgroup.aff.length > 1">
                <span v-for="item2 in item.intro" v-if="item2.lang == lang">
                  {{index === contribgroup.aff.length - 1 ? item2.label ? `${item2.label}. ${item2.text}` : item2.text : item2.label ? `${item2.label}. ${item2.text}；` : `${item2.text}；`}}
                </span>
              </span>
              <span class="mechanism" v-if="contribgroup.aff.length == 1">
                <span v-for="item2 in contribgroup.aff[0].intro" v-if="item2.lang == lang">
                  {{item2.text}}
                </span>
              </span>

            </div>
            <div class="publish-info" v-if="ARTICLE.originalSource && ARTICLE.originalSource.length > 0">
              <p v-for="(item,index) in ARTICLE.originalSource">
                <span class="jo-leading">{{item.lang == 'zh' ? '原文出处：' : 'Original Source：'}}</span>
                  <component v-for="item1 in item.text" :is="'jo' + item1.name" v-bind:key="index"
                             v-bind:data="item1.data"></component>
              </p>
            </div>
            <div class="publish-info">
              <p v-if="this.articlemeta.clc && this.articlemeta.clc.length > 0">
                <span class="jo-leading">{{lang == 'zh' ? '中图分类号：' : 'CLC：'}}</span>
                <span v-for="(clc,index) in this.articlemeta.clc">
                  <component v-for="item in clc" :is="'jo' + item.name" v-bind:key="item.index"
                             v-bind:data="item.data"></component>{{index < articlemeta.clc.length-1 ? '；' : ''}}
                </span>
              </p>
              <p v-if="this.articlemeta.history.opub">
                <span class="jo-leading">{{lang == 'zh' ? '最近更新：' : 'Updated：'}}</span>{{ this.articlemeta.history.opub }}</p>
              <p v-if="this.articlemeta.doi"><span class="jo-leading">DOI：</span>
                <a v-if="showLink"
                :href="articlemeta.doi.indexOf('http')>-1 || articlemeta.doi.indexOf('https')>-1 ? articlemeta.doi : 'http://dx.doi.org/'+articlemeta.doi"
                target="_blank">{{ this.articlemeta.doi }}</a>
                <span v-else>{{ this.articlemeta.doi }}</span>
              </p>
              <p v-if="this.articlemeta.CSTR"><span class="jo-leading">CSTR：</span>
                <a v-if="showLink"
                :href="articlemeta.CSTR.indexOf('http')>-1 || articlemeta.CSTR.indexOf('https')>-1 ? articlemeta.CSTR : 'https://resolve.pid21.cn/resolver?identifier=' + articlemeta.CSTR"
                target="_blank">{{ this.articlemeta.CSTR }}</a>
                <span v-else>{{ this.articlemeta.CSTR }}</span>
              </p>
            </div>
          </div>
        </el-main>
        <el-aside width="auto" class="qrcodeArea">
          <div id="qrcodeArea" style="height: 120px;width: 120px"></div>
        </el-aside>
      </el-container>
      <el-footer height="70px">
        <div class="tabs">
          <ul style="padding-right: 140px;">
            <li class="tabs-item theme-border" v-for="item in tabsArray" :key="item.id" @click="changeTab(item)"
                :class="[currentActive === item.id ? 'active' : '']">
              <span v-text="ARTICLE.defaultlang=='zh'?item.label:item.labelEn"></span>
            </li>
          </ul>
          <div class="changeLanguage">
            <span class="jo-en-btn theme-background" v-if="titlegroup.articletitle.length > 1 || ARTICLE.abstracts.length>1 || ARTICLE.keyword.length>1"
               @click="changeLang()">{{this.lang === 'zh' ? 'EN' : 'CN'}}</span>
            <span :style="{'background-color':ARTICLE.theme,'margin-left': '18px'}" :class="{'jo-copy-btn':true,'jo-en-copy':ARTICLE.defaultlang == 'en'}"  v-clipboard:copy="quoteMessage" v-if="quoteMessage && quoteMessage!==''"
               v-clipboard:success="onCopy">{{ARTICLE.defaultlang === 'zh' ? '引' : 'CITE'}}</span>
            <!--分享按钮组-->
            <span class="jo-share-btn theme-background" style="margin-left: 16px;">
              <i class="icon icon-share"></i>
              <div class="jo-share-box">
                <a href="javascript:void(0);" v-for="item in iconClassArray" :key="item" @click="goShare(item)">
                  <i class="icon" :class="item"></i>
                </a>
              </div>
            </span>
          </div>
          <!--微信分享弹出框-->
          <el-dialog title="分享给微信好友或者朋友圈" width="370px" height="420px" id="wechat-share-box" class="wechat-share-box"
                     :visible.sync="dialogVisible"
                     :modal-append-to-body="false"
                     :modal=false
                     :close-on-click-modal=false>
            <div id="qrcodeArea-share"></div>
            <h5>使用微信“扫一扫”功能。<br/>将此文章分享给您的微信好友或者朋友圈</h5>
          </el-dialog>
        </div>
      </el-footer>
    </el-container>
  </div>

</template>

<script>
  /* eslint-disable */
  import clipboard from '../publish/clipboard.vue'
  import joinlineformula from '../maincontent/body/formula/inlineformula.vue'

  export default {
    components: {
      clipboard,
      joinlineformula
    },
    props: [
      'tabsArray'
    ],
    data() {
      return {
        banner: null,
//        bioWidth: 10,
        lang: this.ARTICLE.defaultlang !=='' ? this.ARTICLE.defaultlang : 'zh',
        titlegroup: this.ARTICLE.titlegroup,
        contribgroup: this.ARTICLE.contribgroup,
        contributes: this.ARTICLE.contribgroup.author,
        articlemeta: this.ARTICLE.articlemeta,
        currentActive: this.component,
        authorDetail: {},
        currentPopover: -1,
        emailImgUrl: require('../../assets/img/email.png'),
        orcidImgUrl: require('../../assets/img/orcid.logo.icon.svg'),
        showPopArray: [],
        languageImg: {
          chUrl: require('../../assets/img/icon-cn.png'),
          enUrl: require('../../assets/img/icon-en.png'),
          quoteUrl: require('../../assets/img/icon-quote.png')
        },
        quoteMessage: '', //引文信息
        iconClassArray: [
          "icon-qq", "icon-zone", "icon-wechat", "icon-email", "icon-blog"
        ],
        dialogVisible: false,
        authorAff:[]
      };
    },
    created() {
      //根据默认语言设置初始页面语言
      this.$bus.emit('currentLang', this.ARTICLE.defaultlang);
      /*if (this.contribgroup.translator && this.contribgroup.translator.length > 0) {
          for (let i = 0; i < this.contribgroup.translator.length; i++) {
            this.contribgroup.translator[i].role.push("trans")
          }
        this.contributes = this.contributes.concat(this.contribgroup.translator);
      }
      if (this.contribgroup.reviewer && this.contribgroup.reviewer.length > 0) {
        for (let i = 0; i < this.contribgroup.reviewer.length; i++) {
          this.contribgroup.reviewer[i].role.push("reviewer")
        }
        this.contributes = this.contributes.concat(this.contribgroup.reviewer);
      }*/

      //作者机构上标
      if (this.ARTICLE.contribgroup.aff.length > 1) {
        for (let i in this.contributes) {
          let aff = ''
          for (let j in this.contributes[i].aff) {
            if (j == 0) {
              aff = this.contributes[i].aff[j].text;
            } else if(this.contributes[i].aff[j].text !== '') {
              aff = aff + ',' + this.contributes[i].aff[j].text;
            }
          }
          this.authorAff[i] = aff;
        }
      }

    },
    mounted() {
      if(this.$refs.topbarheight.offsetHeight && this.$refs.topbarheight.offsetHeight > 10){
        this.GLOBAL.topbarheight = this.$refs.topbarheight.offsetHeight;
      }
      if(this.GLOBAL.topbarheight == 0 || this.GLOBAL.topbarheight == 10 ){
        var that = this;
        setTimeout(() => {
          var topbar = document.getElementById('jo-topbar');
          if(topbar && topbar.offsetHeight != 'undefined' && topbar.offsetHeight!= 0 ){
            that.GLOBAL.topbarheight = topbar.offsetHeight;
            that.$bus.emit('topbarheight', that.GLOBAL.topbarheight);
          }
        },1000)
      }
      this.generateCode();
      if (this.ARTICLE.articlemeta.citeme.length>0){
        for (let i in this.ARTICLE.articlemeta.citeme) {
          if (i == 0) {
            this.quoteMessage = this.ARTICLE.articlemeta.citeme[i].text;
          } else {
            this.quoteMessage = `${this.quoteMessage}\r\n${this.ARTICLE.articlemeta.citeme[i].text}`;
          }
        }
      }
      //banner加载及计算
      if (this.ARTICLE.banner) {
        this.$http.get('http://' + this.ARTICLE.banner).then(function (response) {
          // response.data中获取ResponseData实体
          if(response.body.bannerUrl){
            this.banner = 'http://' + response.body.bannerUrl;
            var that = this;
            this.$nextTick(function () {
              let img = document.getElementById('topbarBanner')
              if (img != null) {
                img.onload = function () {
                  that.GLOBAL.topbarheight = that.$refs.topbarheight.offsetHeight;
                  that.$bus.emit('topbarheight', that.GLOBAL.topbarheight);
                }
                img.onerror = function () {
                  this.style.display = 'none'
                }
              }
            })
          }
        }, function () {
          // 发生错误
          if (window.console) {
            console.log('连接失败！');
          }
        });
      }
      window.onresize = function () {
        var innerWinWidth = window.innerWidth;
        if (innerWinWidth < 800) {
          if(!$('.tabs-item').eq(0).hasClass("active")){
            $('.tabs-item').eq(0).click()
          }
        }
      }
    },
    methods: {
      generateCode() {
        $('#qrcodeArea').qrcode({
          render: "canvas",
          height: 120,
          width: 120,
          correctLevel: 0,
          text: window.location.href
        });
      },
      changeLang() {
        if (this.lang == "zh") {
          this.lang = "en";
          this.$bus.emit('currentLang', "en");
        } else if(this.lang == "en") {
          this.lang = "zh";
          this.$bus.emit('currentLang', "zh");
        }
        this.$nextTick(() => {
          this.GLOBAL.topbarheight = this.$refs.topbarheight.offsetHeight;
          this.$bus.emit('topbarheight', this.GLOBAL.topbarheight);
          if (typeof MathJax !== 'undefined') {
            MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
          }
        });

      },
      changeTab(itemObj) {
        //通知父组件改变tab页
        this.currentActive = itemObj.id;
        this.$emit("childByValue", [itemObj.name,itemObj.id]);
      },
      showAuthorDetail(index) {
        this.currentPopover = index;
        var currentAuthor = this.contributes[index];  //当前作者
        var affList = this.contribgroup.aff;     //机构列表
        let authorDetailData = {
          noCnInfo:true,
          noEnInfo:true,
          mechanism: [],
          orcid: '',
          email: '',
          phone: '',
          role: [],
          briefIntro: '',
          firstIntro: '',
          supervisorIntro: '',
          bioIntro: {
            data: [],
            graphic: []
          }
        };
        if (currentAuthor.orcid && currentAuthor.orcid !== ''){
          authorDetailData.orcid = currentAuthor.orcid
        }

        // 机构列表
        let authorAffIds = [];
        if (currentAuthor.aff && currentAuthor.aff.length>0){
          currentAuthor.aff.forEach(element => {
            authorAffIds.push(element.rid);
          });

          for (var i in authorAffIds) {
            for (var j in affList) {
              if (authorAffIds[i] == affList[j].id) {
                let tempAff = {};
                for (var k in affList[j].intro){
                  if(this.lang&&affList[j].intro[k].lang == this.lang){
                    tempAff.label = affList[j].intro[k].label
                    tempAff.text = affList[j].intro[k].text
                  }
                }

                if(JSON.stringify(tempAff)!='{}'){
                  authorDetailData.mechanism.push(
                    tempAff
                  );
                  if(this.lang=='zh'&&authorDetailData.noCnInfo){
                    authorDetailData.noCnInfo = false;
                  }else if(this.lang=='en'&&authorDetailData.noEnInfo){
                    authorDetailData.noEnInfo = false;
                  }
                }
              }
            }
          }
        }

        // 邮箱
        authorDetailData.email = currentAuthor.email || '';
        authorDetailData.phone = currentAuthor.phone || '';

        if(authorDetailData.email!=''||authorDetailData.phone!=''){
          if(this.lang=='zh'&&authorDetailData.noCnInfo){
            authorDetailData.noCnInfo = false;
          }else if(this.lang=='en'&&authorDetailData.noEnInfo){
            authorDetailData.noEnInfo = false;
          }
        }
        // 第一作者简介
        if (currentAuthor.first || currentAuthor.role && currentAuthor.role.indexOf('first-author') > -1) {
          if (currentAuthor.first) {
            for (var i in currentAuthor.first) {
              if (currentAuthor.first[i].lang == this.lang) {
                authorDetailData.firstIntro = currentAuthor.first[i].text;
              }
            }
          }
          // 角色
          authorDetailData.role.push(this.lang == 'zh' ? '第一作者' : 'First author');
        }
        // 通讯作者简介
        if (currentAuthor.corresp || currentAuthor.role && currentAuthor.role.indexOf('corresp') > -1) {
          if (currentAuthor.corresp) {
            for (var i in currentAuthor.corresp) {
              if (currentAuthor.corresp[i].lang == this.lang) {
                authorDetailData.briefIntro = currentAuthor.corresp[i].text;
              }
            }
          }
          authorDetailData.role.push(this.lang == 'zh' ? '通信作者' : 'Corresponding author');
        }
        if (currentAuthor.role && currentAuthor.role.indexOf('equal') > -1) {
          authorDetailData.role.push(this.lang == 'zh' ? '同等贡献者' : 'Contribute equally');
        }
        if (currentAuthor.role && currentAuthor.role.indexOf('trans') > -1) {
          authorDetailData.role.push(this.lang == 'zh' ? '翻译' : 'Translator');
          authorDetailData.noCnInfo = false;
        }
        if (currentAuthor.role && currentAuthor.role.indexOf('reviewer') > -1) {
          authorDetailData.role.push(this.lang == 'zh' ? '校对' : 'Reviewer');
          authorDetailData.noCnInfo = false;
        }
        // 作者简介
        if (currentAuthor.note) {
          if (authorDetailData.briefIntro == '') {
            for (var i in currentAuthor.note) {
              if (currentAuthor.note[i].lang == this.lang && currentAuthor.note[i].text && currentAuthor.note[i].text!=='') {
                authorDetailData.briefIntro = currentAuthor.note[i].text;
                if (this.lang == 'zh' && authorDetailData.noCnInfo) {
                  authorDetailData.noCnInfo = false;
                } else if (this.lang == 'en' && authorDetailData.noEnInfo) {
                  authorDetailData.noEnInfo = false;
                }
              }
            }
          }
        }
        //导师简介
        if (currentAuthor.supervisor) {
          for(var i in currentAuthor.supervisor){
            if(currentAuthor.supervisor[i].lang == this.lang){
              authorDetailData.supervisorIntro = currentAuthor.supervisor[i].text;
            }
          }
        }

        if(currentAuthor.corresp||currentAuthor.first||currentAuthor.supervisor){
          if(authorDetailData.noCnInfo&&this.lang=='zh'){
            authorDetailData.noCnInfo = false;
          }else if(this.lang=='en'&&authorDetailData.noEnInfo){
            authorDetailData.noEnInfo = false;
          }
        }

        //bio简介 带图片的作者简介
        if(currentAuthor.bio){
          for(var i in currentAuthor.bio){
            if(currentAuthor.bio[i].lang == this.lang){
              authorDetailData.bioIntro.data = currentAuthor.bio[i].data
              if (currentAuthor.bio[i].graphic){
              authorDetailData.bioIntro.graphic = currentAuthor.bio[i].graphic;
//              this.bioWidth = authorDetailData.bioIntro.graphic.width * this.GLOBAL.deviceDPI.x / 25.4;
              }
              if(this.lang=='zh'&&authorDetailData.noCnInfo){
                authorDetailData.noCnInfo = false;
              }else if(this.lang=='en'&&authorDetailData.noEnInfo){
                authorDetailData.noEnInfo = false;
              }
            }
          }
        }
        this.authorDetail = authorDetailData;

      },
      closePopover(index) {
        this.showPopArray.splice(index, 1, false);
      },

      onCopy: function () {
        this.$message.closeAll();
        this.$message({
          message: '引文信息已复制，您可以直接黏贴',
          type: 'success',
          customClass:'quote-message-box'
        });
      },
      sendEmail(url){
        if(url){
          window.location.href = 'mailto:' + url;
        }else{
          this.$message.closeAll();
          this.$alert('sorry，该通讯作者居然没有留下通讯邮箱~','',{
            confirmButtonText:'我知道了',
            customClass:'jo-email-alert',
            closeOnClickModal:true
          });
        }
//
      },
      /*触发分享*/
      goShare(item) {
        var shareUrl = null;
        var title = this.getTitle();
        var url = window.location.href;
        var desc = "推荐好文：%0D" + "看到一篇不错的文章《" + title + "》，值得一看，推荐给大家。";
        if (item == 'icon-email') {
          var subject = "推荐好文《" + title
            + "》&body=你好！看到了一篇不错的文章，值得一看，分享给您，欢迎共同讨论。%0A可点击以下地址阅读全文："
            + url;
          window.location.href = 'mailto:?subject=' + subject;
        } else if (item == 'icon-wechat') {
          this.dialogVisible = true;
          /*延时触发(待优化）*/
          setTimeout(() => {
            if ($('#qrcodeArea-share').children().length == 0) {
              $('#qrcodeArea-share').qrcode({
                render: "canvas",
                height: 300,
                width: 300,
                correctLevel: 0,
                text: window.location.href
              });
            }
          }, 0)
        } else {
          var top = (window.outerHeight - 505) / 2;
          var left = (window.outerWidth - 615) / 2;
          //分享到微博
          if (item == 'icon-blog') {
            shareUrl = "http://v.t.sina.com.cn/share/share.php?title=" + desc + "&url=" + url + "&searchPic=true";
          }
          //分享到QQ好友
          else if (item == 'icon-qq') {
            shareUrl = "http://connect.qq.com/widget/shareqq/index.html?title=" + title.substr(0,40) + '&desc=' + desc + "&url=" + url;
          }
          //分享到QQ空间
          else if (item == 'icon-zone') {
            shareUrl = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?title=' + title.substr(0,40) + '&desc=' + desc + '&url=' + url;
          }
          window.open(shareUrl, '_blank', 'width=615,height=505,top=' + top + ',left=' + left);
        }
      },
      getTitle() {
        var title = ''
        var titleData = null
        if (this.titlegroup.articletitle) {
          for(var i in this.titlegroup.articletitle){
            if(this.titlegroup.articletitle[i].lang == this.lang){
              titleData =  this.titlegroup.articletitle[i].data
              if (Array.isArray(titleData)) {
                titleData.forEach((item, index) => {
                  title += item.data;
                })
              } else {
                title = titleData;
              }
            }
          }
        }
        if (this.titlegroup.subtitle) {
          for(var i in this.titlegroup.subtitle){
            if(this.titlegroup.subtitle[i].lang == this.lang){
              title = title + "-" + this.titlegroup.subtitle[i].data;
            }
          }
        }
        return title;
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/mixins";
  .jo-banner {
    img {
      width: 100%;
      height: 100%;
    }
  }

  .active {
    color: rgb(0, 162, 175);
  }

  .jo-topbar {
    /*border-bottom: 1px solid #c3caca;*/
    position: relative;
    width: 100%;
    z-index: 100;
    background-color: #fff;
    -webkit-box-shadow: 0 6px 8px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: 0 6px 8px rgba(0, 0, 0, 0.05);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.05);
    .qrcodeArea {
      height: 130px;
      overflow: hidden;
      margin: 30px 30px 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #cccccc;
      padding: 2px;
      /*@include screen(0px,800px){
        display: none;
      }*/
    }
    .el-main {
      padding: 30px 10px 0 20px;
      position: relative;
      .topbar_title {
        font-size: 2.2rem;
        color: #424e5c;
        letter-spacing: 0.03em;
        line-height: 34px;
        margin-bottom: 10px;
      }
      .topbar_subtitle {
        font-size: 1.8rem;
        color: #666;
        font-weight: 400;
        margin-top: 10px;
        margin-bottom: 10px;
        letter-spacing: 0.03em;
        line-height: 26px;
        padding: 5px;
        background: none;
      }
      .affs {
        text-align: left;
        font-size: 1.2rem;
        line-height: 25px;
        color: #666;
        span.mechanism{
          display: block;
        }
      }
      .publish-info {
        max-width: 100%;
        margin-top: 5px;
        line-height: 25px;
        color: #666;
        & > p {
          display: inline-block;
          width: auto;
          height: 25px;
          margin-right: 28px;
          font-size: 1.2rem;
          .jo-leading {
            color: #999;
            margin-right: 5px;
          }
        }
      }
    }

    .el-footer{

     /* @include screen(0px,800px){
        margin-top:  -30px;
      }*/
    }
    .tabs {
      position: relative;
      height: 60px;
      /*@include screen(0px,800px){
        height: 10px;
      }*/
      line-height: 58px;
      padding-top: 9px;
      & > ul {
        /*@include screen(0px,800px){
          display: none;
        }*/
        overflow: hidden;
        .tabs-item {
          width:calc(20% - 10px);
          max-width: 132px;
          display: inline-block;
          white-space: nowrap;
          margin-right: 5px;
          cursor: pointer;
          text-align: center;
          span {
            font-size: 1.8rem;
            color: #83898a;
            vertical-align: middle;
          }

        }
        .active {
          border-bottom: 2px solid #00a2af;
          font-weight: bold;
          span {
            color: #00a2af;
          }
        }
      }
      .changeLanguage {
        position: absolute;
        top: 10px;
        right: 10px;
        /*@include screen(0px,800px){
          top: 15px;
        }*/
        .jo-copy-btn, .jo-en-btn, span {
          width: 30px;
          height: 20px;
          display: inline-block;
          text-align: center;
          line-height: 20px;
          text-transform: uppercase;
          border-radius: 3px;
          color: #fff;
          font-size: 14px;
          background: #00a2af;
          cursor: pointer;
          -webkit-transition-duration: 0.3s;
          transition-duration: 0.3s;
          -webkit-transition-property: all;
          transition-property: all;
        }
        .jo-en-copy{
          width: 40px !important;
        }

        .jo-copy-btn:hover, .jo-en-btn:hover, span:hover {
          -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          -moz-box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        }
        img {
          cursor: pointer;
        }
      }
    }

  }

  .jo-author-items {
    padding: 0;
    margin: 0;
    font-size: 1.4rem;
    line-height: 20px;
  }

  li p{
    font-size: 12px;
  }

  .jo-author-item {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    margin-right: 16px;
    font-size: 14px;
    color: #00a2b1;
    list-style-type: none;
    padding: 0 5px;
    text-align: center;
    border-radius: 4px;
    &:hover {
      /*background-color: #cccccc;*/
    }
    .author {
      cursor: pointer;
    }
    .deceased {
      border: 1px solid #000000;
    }

    sup {
      line-height: 0;
      font-size: 0.8em;
    }
    a.jo-orcid {
      img{
        width: 16px;
      }
    }

  }

  .popoverUl {
    font-size: 12px;
    /*color: white;*/
    text-align: left;
    word-wrap: break-word;
    word-break: normal;
    & > li {
      line-height: 20px;
      label {
        font-weight: bold;
      }
    }
    .el-icon-close {
      position: absolute;
      top: 0;
      right: 0;
      padding: 3px 3px 0 3px;
      background-color: #f8feff;
      cursor: pointer;
      border-radius: 5px;
      &:hover {
        color: #00a2b1;
      }
    }
  }

  /*分享按钮*/
  .jo-share-btn {
    position: relative;
    top: 5px;
    .jo-share-box {
      display: none;
      position: absolute;
      right: -15px;
      top: 20px;
      min-width: 230px;
      padding: 17px 20px;
      text-align: center;
      font-size: 0;
      background: url("../../assets/img/bg-share.png") no-repeat right top;
      background-size: 100% 60px;
      a {
        display: inline-block;
        margin: 0 5px;
        i.icon {
          width: 28px;
          height: 28px;
          opacity: 1;
          display: inline-block;
          position: relative;
        }
        i.icon-qq {
          background: url("../../assets/img/icon-qq.png") no-repeat center;
        }

        i.icon-zone {
          background: url("../../assets/img/icon-zone.png") no-repeat center;
        }

        i.icon-wechat {
          background: url("../../assets/img/icon-wechat.png") no-repeat center;
        }
        i.icon-email {
          background: url("../../assets/img/email1.png") no-repeat center;
          background-size: 25px 25px;
        }
        i.icon-blog {
          background: url("../../assets/img/icon-blog.png") no-repeat center;
        }
      }

      a:hover {
        i.icon {
          opacity: .8;
        }
      }
    }
    .jo-share-box:hover {
      display: block;
    }
    i.icon-share {
      display: inline-block;
      position: relative;
      width: 30px;
      height: 20px;
      opacity: 1;
      background: url("../../assets/img/icon-share.png") no-repeat center;
    }
  }

  .jo-share-btn:hover {
    .jo-share-box {
      display: block;
    }
  }
</style>

<!--微信分享弹窗，修改了el-dialog自带样式，单独处理-->
<style lang="scss">

  .wechat-share-box {
    .el-dialog {
      .el-dialog__header {
        padding: 2px 20px 10px !important;
      }
    }

    #qrcodeArea-share {
      display: inline-block;
      width: 300px;
      height: 300px;
      margin: -30px 12px 10px 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #cccccc;
      padding: 5px;
    }

    h4 {
      text-indent: 1rem;
      line-height: 40px;
      font-size: 1.4rem;
      font-weight: bold;
    }
    h5 {
      line-height: 16px;
      font-size: 1.4rem;
      color: #666;
      padding: 15px 30px;
    }
  }
  .jocontainer{
    .el-main{
      width: calc(100% - 174px);
      display: inline-block;
    }
    .el-aside{
      display: inline-block;
    }
  }
  .jo-email-alert{
    vertical-align:top;
    .el-button--primary{
      background-color:#00a2b1;
      border-color: #00a2b1;
    }
  }
  .v-modal{
    background:none !important;
  }
</style>
<!--弹出框样式结束-->



// WEBPACK FOOTER //
// src/components/topbar/topbar.vue